import { featureIcons } from '@/components/Menu/featureicons';
import { getEnsureLoadedLoader } from './loaderHelper';

export const useCategoriesLoader = (AddLoader: (loader: () => Promise<void>, key: string, icon?: string) => void) => {
    AddLoader(getEnsureLoadedLoader('Categories'), 'categories.loading_categories', featureIcons.CATEGORY);
};
